import { findDOMNode } from 'react-dom';

export function parseTableNode(table) {
  const body = table.querySelector('tbody');
  const bodyRows = getRows(body);

  const header = table.querySelector('thead');
  const headerRows = header ? getRows(header) : null;

  return {
    bodyClass: body.className,
    bodyRows,
    cellContentById: getCellContentById(table),
    columns: getColumns(bodyRows, headerRows),
    headerClass: header ? header.className : null,
    headerRows
  };
}

function getRows(section) {
  const rows = [];

  for (const row of section.querySelectorAll('tr')) {
    const cells = [];

    for (const cell of row.querySelectorAll('td, th')) {
      cells.push(buildCell(cell));
    }

    rows.push({
      cells,
      class: row.className,
      style: row.getAttribute('style')
    });
  }

  return rows;
}

function buildCell(cell) {
  return {
    class: cell.className,
    id: cell.getAttribute('bo-table-cell'),
    style: cell.getAttribute('style')
  };
}

function getCellContentById(table) {
  const cellContentById = {};

  for (const cell of table.querySelectorAll('th, td')) {
    cellContentById[cell.getAttribute('bo-table-cell')] = cell.innerText;
  }

  return cellContentById;
}

function getColumns(bodyRows, headerRows) {
  const row = bodyRows[0];
  if (row) {
    return row.cells.map(cell => ({ class: cell.class, style: cell.style }));
  } else if (headerRows && headerRows.length) {
    // Don't use header classes/styles for new body rows, but still make empty column objects
    return [...new Array(headerRows[0].cells.length).keys()].map(() => ({}));
  } else {
    return [];
  }
}

export function selectCellContent(cellComponent) {
  // eslint-disable-next-line react/no-find-dom-node
  const node = findDOMNode(cellComponent).querySelector('[contenteditable]');
  const doc = node.ownerDocument;

  const range = doc.createRange();
  range.selectNodeContents(node);

  const selection = doc.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
}

export function addBlurHandler(tableComponent, id, doc, callback) {
  tableComponent.domHelper = tableComponent.domHelper || { doc };
  tableComponent.domHelper.blurHandler = tableComponent.domHelper.blurHandler || ((event) => {
    // Clicking a button to move a column or row to the end of a table will cause the button to stop
    // being rendered. This happens before the blur event triggers, resulting in the event target
    // not being part of the DOM, rendering the closest('.table-component') check useless.
    if (event.target.classList.contains('table-edit-control')) {
      return;
    }

    const targetTableComponent = event.target.closest('.table-component');
    if (targetTableComponent && targetTableComponent.id === id) {
      return;
    }

    callback(event);
  });

  // The provided document is the IFrame's, but the top-level documnet needs the listener too
  doc.addEventListener('click', tableComponent.domHelper.blurHandler);
  document.addEventListener('click', tableComponent.domHelper.blurHandler);
}

export function removeBlurHandler(tableComponent) {
  const { domHelper } = tableComponent;
  if (domHelper && domHelper.blurHandler) {
    domHelper.doc.removeEventListener('click', tableComponent.domHelper.blurHandler);
    document.removeEventListener('click', tableComponent.domHelper.blurHandler);
  }
}
